<div class="layout-container">
    <app-operations [isCollapsed]="isCollapsed"></app-operations>
    <div class="main-content">
        <app-top-bar (toggleSidebar)="handleToggle()"></app-top-bar>
        @if(loaderIcon | async){
            <app-loader></app-loader>
        }
        <form [formGroup]="vendorSettingForm">
            <div class="content-area" [userPermissionHandler]="viewPermissionHandlerData">
                <div class="d-flex justify-content-between align-items-center mb-3">
                    <h5 class="fw-semibold">{{'Vendor' | wordReplace}} Settings</h5>
                </div>
                <hr />
                <div class="row mb-3 align-items-center">
                    <div class="col-md-6 col-lg-9">
                        <label class="form-label fw-semibold">{{'Vendor' | wordReplace}} Name Format</label>
                    </div>
                    <div class="col-md-6 col-lg-3">
                        <select class="form-select" formControlName="vendorNameFormat">
                            <option *ngFor="let item of vendorNamingConventions" [value]="item.VendorNamingConventionId"
                                style="text-align: left;">
                                {{item.VendorNamingConvention}}
                            </option>
                        </select>
                    </div>
                    <div class="col-md-6 col-lg-9 mt-3">
                        <label class="form-label">{{'Vendor' | wordReplace}} Name Case Format</label>
                    </div>
                    <div class="col-md-6 col-lg-3 mt-3">
                        <select class="form-select" formControlName="vendorCaseFormat">
                            <option *ngFor="let item of vendorCasingCoventions" [value]="item.Id"
                                style="text-align: left;">
                                {{item.Name}}
                            </option>
                        </select>
                    </div>
                </div>

                <hr>
                <div class="row">
                    <div class="col-12 text-start">
                        <h6>Default display of Product while creating new {{'vendors' | wordReplace}}</h6>
                    </div>
                </div>
                <div class="row mb-3 align-items-center">
                    <div class="col-md-6 col-lg-4 align-items-center d-inline">
                        <input class="form-check-input me-2" type="checkbox" formControlName="defaultProductDisplay"
                            id="defaultProduct" checked>
                        <label class="form-label fw-semibold mb-0 ms-1">Default Product Display</label>
                    </div>
                    <div class="col-md-6 col-lg-5 align-items-center text-lg-end">
                        <label class="form-check-label mb-0" for="defaultProduct">Product</label>
                    </div>
                    <div class="col-md-6 col-lg-3">
                        <select class="form-select" formControlName="product">
                            <option value="0">--Select Product--</option>
                            <option *ngFor="let item of marketProductList" [value]="item.ProductId">
                                {{item.ProductDescription}}
                            </option>
                        </select>
                    </div>
                </div>

                <hr>
                <div class="row mb-3">
                    <div class="col-12">
                        <h6 class="mb-2">Close Out Booking Setting</h6>
                    </div>

                    <div class="col-md-3">
                        <label>Vendor ID</label>
                        <input type="text" class="form-control" formControlName="closeOutVendorAlphaNumericId"
                            (blur)="getVendorById()">
                    </div>
                    <div class="col-md-3 d-flex" style="margin-top: 18px;">
                        <input type="text" class="form-control me-2" style="height: 42px"
                            formControlName="closeOutVendorName" readonly>
                        <button type="button" class="btn btnAS d-flex align-items-center justify-content-center"
                            style="width: 40px; height: 40px;" (click)="openVendorModal()">
                            <img src="./assets/images/search.svg" class="img-fluid">
                        </button>
                    </div>
                    <div class="col-md-12 col-lg-3 text-start text-lg-end">
                        <label class="mt-1">Product</label>
                    </div>
                    <div class="col-md-6 col-lg-3">
                        <select class="form-select" formControlName="closeOutProductId">
                            <option *ngFor="let item of marketProductSelectedList" [value]="item.ProductID">
                                {{ item.ProductDescriptions }}
                            </option>
                        </select>
                    </div>
                </div>
                <hr />
                <div class="form-check">
                    <input class="form-check-input me-2" type="checkbox" formControlName="enableWebInquiry"
                        id="EnableWebInquiry" checked>
                    <label class="form-check-label fw-semibold mb-0" for="EnableWebInquiry">Enable Web Inquiry Access
                        for
                        New {{'Vendors' | wordReplace}}</label>
                </div>
                <div class="row">
                    <div class="col-12 text-end my-3">
                        <button class="btn btnAS me-1" [userPermissionHandler]="editPermissionHandlerData" (click)="saveVendorGeneralSetting()">Save</button>
                        <button class="btn btn-orange me-1" (click)="routeBack()">Cancel</button>
                    </div>
                </div>
            </div>
        </form>
    </div>
    <!-- Modal with Vendor Search Component -->
    <div class="modal fade" id="vendorSearchModal" #vendorSearchModal tabindex="-1" aria-labelledby="vendorSearchLabel"
        aria-hidden="true">
        <div class="modal-dialog modal-lg modal-dialog-centered">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title" id="vendorSearchLabel">
                        {{'Select Vendor' | wordReplace}}
                    </h5>
                    <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                </div>
                <div class="modal-body">
                    <app-vendor-search [isVendorPopUp]="true" [VendorFilterOption]="VendorFilterOption"
                        (vendorSearchRoute)="onVendorSelected($event)">
                    </app-vendor-search>
                </div>
            </div>
        </div>
    </div>
</div>